import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "slideEvent" ]

  initialize() {
    this.showCurrentSlide()
  }

  next() {
    this.index++
  }

  previous() {
    this.index--
  }

  showCurrentSlide() {
    let size = document.querySelectorAll(".slide-events .slide").length - 1
    if (this.index > size) {
      this.index = 0
    } else if (this.index < 0) {
      this.index = size
    }
    this.slideEventTargets.forEach((el, i) => {
      el.classList.toggle("slide--current", this.index == i)
    })
  }

  get index() {
    return parseInt(this.data.get("index"))
  }

  set index(value) {
    this.data.set("index", value)
    this.showCurrentSlide()
  }
}
